(() => {
  const menu = document.querySelector('[data-mobile-menu]');
  let menuOpener = null;
  if (menu) {
    const menuFocusable = () => Array.from(menu.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(el => el.offsetParent !== null);
    document.querySelectorAll('[data-menu-toggle]').forEach(button => button.addEventListener('click', () => { menuOpener = button; }));
    document.querySelectorAll('[data-menu-close]').forEach(button => button.addEventListener('click', () => requestAnimationFrame(() => menuOpener?.focus())));
    document.addEventListener('keydown', event => {
      if (!menu.classList.contains('is-open')) return;
      if (event.key === 'Escape') { requestAnimationFrame(() => menuOpener?.focus()); return; }
      if (event.key !== 'Tab') return;
      const items = menuFocusable(); if (!items.length) return;
      if (event.shiftKey && document.activeElement === items[0]) { event.preventDefault(); items.at(-1).focus(); }
      else if (!event.shiftKey && document.activeElement === items.at(-1)) { event.preventDefault(); items[0].focus(); }
    });
  }

  const modal = document.querySelector('[data-waitlist-dialog]');
  if (modal) {
    const panel = modal.querySelector('[role="dialog"]');
    const email = modal.querySelector('input[type="email"]');
    const interest = modal.querySelector('[data-waitlist-interest]');
    let waitlistOpener = null;
    const open = (opener, product = '') => {
      waitlistOpener = opener || document.activeElement;
      if (interest) interest.value = product ? 'Interested in: ' + product : 'General launch waitlist';
      modal.hidden = false;
      document.body.classList.add('waitlist-open');
      requestAnimationFrame(() => (email || panel).focus());
    };
    const close = () => {
      modal.hidden = true;
      document.body.classList.remove('waitlist-open');
      if (waitlistOpener && document.contains(waitlistOpener)) waitlistOpener.focus();
    };
    document.querySelectorAll('[data-waitlist-open]').forEach(button => button.addEventListener('click', () => open(button, button.dataset.waitlistProduct || '')));
    modal.querySelectorAll('[data-waitlist-close]').forEach(button => button.addEventListener('click', close));
    modal.addEventListener('keydown', event => {
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;
      const items = Array.from(modal.querySelectorAll('button:not([disabled]),input:not([disabled]),a[href]')).filter(el => el.offsetParent !== null);
      if (!items.length) return;
      if (event.shiftKey && document.activeElement === items[0]) { event.preventDefault(); items.at(-1).focus(); }
      else if (!event.shiftKey && document.activeElement === items.at(-1)) { event.preventDefault(); items[0].focus(); }
    });

    document.addEventListener('submit', event => {
      const form = event.target.closest('form[data-add-form]');
      if (!form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const root = form.closest('[data-product-root]');
      const product = root?.querySelector('.pdp__title')?.textContent?.trim() || '';
      open(form.querySelector('[type="submit"]'), product);
    }, true);

    document.querySelectorAll('[data-add-button]').forEach(button => {
      button.type = 'button';
      button.disabled = false;
      button.innerHTML = 'Join the waitlist&nbsp;&nbsp;→';
      button.removeAttribute('data-add-button');
      button.setAttribute('data-waitlist-open','');
      button.addEventListener('click', () => {
        const product = button.closest('[data-product-root]')?.querySelector('.pdp__title')?.textContent?.trim() || '';
        open(button, product);
      });
    });
    document.querySelectorAll('.purchase-option,.pdp__variants').forEach(el => el.hidden = true);

    const submitted = new URLSearchParams(location.search).get('customer_posted') === 'true';
    if (submitted || modal.querySelector('[data-waitlist-success]')) open(null);
    else if (!sessionStorage.getItem('essntlWaitlistSeen')) {
      sessionStorage.setItem('essntlWaitlistSeen','1');
      window.setTimeout(() => open(null), 1100);
    }
  }

  const status = document.querySelector('.form-message[tabindex="-1"]');
  if (status) status.focus();
})();